import React from 'react';

import {FormItemSkeleton, SkeletonItem} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';


export const MicroSiteBaseInfoSkeleton = () => (
    <Group direction="v" alignItems="start">
        <FormItemSkeleton labelWidth={106}>
            <SkeletonItem width={300} height={30}/>
        </FormItemSkeleton>
        <FormItemSkeleton labelWidth={106}>
            <SkeletonItem width={750} height={350}/>
        </FormItemSkeleton>
    </Group>
);
